import RentalTableRow from "../common/Rentals/RentalTableRow";

const UNITS_ROW_CONFIG = {
  showGuideInfo: false,
  showPmsId: true,
  showEditButton: true,
  showViewButton: false,
  showPrintButton: false,
  showShareButton: false,
  showMonitoringButton: true,
  showQRButton: false,
  showCloneButton: true,
  showDetailButton: true,
  editPath: "/units",
  shareModalId: "#share-modal",
  monitoringModalId: "#smart-lock-monitoring-modal",
  deleteModalId: "#modal-property-delete",
};

const TableRow = ({ guide, index, allTags, onZoneToggle }) => {
  return (
    <RentalTableRow
      guide={guide}
      index={index}
      allTags={allTags}
      config={UNITS_ROW_CONFIG}
      onZoneToggle={onZoneToggle}
    />
  );
};

export default TableRow;
